import dayjs from "dayjs";

export default function formatDate(timestamp) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".";

  var today = dayjs().startOf("day");
  var yesterday = today.subtract(1, "day");
  var theDayBeforeYesterday = today.subtract(2, "day");
  if (timestamp >= today.unix()) {
    return dayjs.unix(timestamp).format("HH:mm");
  } else if (timestamp >= yesterday.unix()) {
    return dayjs.unix(timestamp).format("昨天 - HH:mm");
  } else if (timestamp >= theDayBeforeYesterday.unix()) {
    return dayjs.unix(timestamp).format("前天 - HH:mm");
  } else {
    return dayjs.unix(timestamp).format("YYYY" + separator + "MM" + separator + "DD - HH:mm");
  }
}